import { ref, onBeforeMount } from "vue";
import { useRoute, useRouter, onBeforeRouteUpdate } from "vue-router/composables";
/**
 * Sets and receives hash value from url to open specific tab
 * @param defaultTab string value to set default tab that is open by default
 */
export function useTabHistory(defaultTab) {
    const router = useRouter();
    const route = useRoute();
    const tabSelected = ref(defaultTab !== null && defaultTab !== void 0 ? defaultTab : 0);
    onBeforeRouteUpdate((to, from, next) => {
        if (to.hash && to.hash != "#dialog") {
            sessionStorage.setItem("ignoreScrollBehavior", "true");
            tabSelected.value = to.hash.split("#")[1] || to.hash;
        }
        next();
    });
    onBeforeMount(() => {
        if (!tabSelected.value)
            return;
        if (route.hash) {
            tabSelected.value = route.hash.split("#")[1];
            return;
        }
        window.requestAnimationFrame(() => {
            // Needs to be in this callback or else it won't work when it replaces
            sessionStorage.setItem("ignoreScrollBehavior", "true");
            router.replace({
                ...route,
                hash: `#${defaultTab}`
            });
        });
    });
    /**
     * For setting hash trough link element
     * @param evt MouseEvent
     */
    function historyTabClick(evt) {
        const target = evt.currentTarget;
        const hash = new URL(target.href).hash;
        if (route.hash === hash)
            return; // Otherwise throws duplication error
        sessionStorage.setItem("ignoreScrollBehavior", "true");
        router.push({
            ...route,
            hash
        });
    }
    /**
     * For setting hash to url and tabSelected value manually
     * @param hash hash value with #
     */
    function setHistoryTab(hash) {
        tabSelected.value = hash.split("#")[1];
        if (route.hash === hash)
            return; // Otherwise throws duplication error
        sessionStorage.setItem("ignoreScrollBehavior", "true");
        router.push({
            ...route,
            hash
        });
    }
    return {
        tabSelected,
        historyTabClick,
        setHistoryTab
    };
}
